import type SearchResult from "./SearchResult.ts";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { dispatch } from "../utils/events.ts";

export default class SearchResults extends AlpineComponent {
  constructor() {
    super();
  }

  init() { }

  destroy() { }

  getSearchResults(): { results: SearchResult[]; index: number } {
    const items = this.$el.querySelectorAll(".search-result");
    const results: SearchResult[] = [];
    let index = -1;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const searchResult = window.Alpine.$data(
        item as HTMLElement
      ) as SearchResult;
      results.push(searchResult);
      if (searchResult.selected) {
        index = i;
      }
    }
    return { results, index };
  }

  onSearchResultSelected(e: CustomEvent<SearchResult>) {
    const el = this.$el;
    const selected = e.detail.$el;
    const cB = el.getBoundingClientRect();
    const sB = selected.getBoundingClientRect();

    // Scroll to the selected element if it's not visible in the container
    if (sB.top < cB.top) {
      // If the element is above the visible area, scroll it into view at the top
      selected.scrollIntoView({ block: "start", behavior: "instant" });
    } else if (sB.bottom > cB.bottom) {
      // If the element is below the visible area, scroll it into view at the bottom
      selected.scrollIntoView({ block: "end", behavior: "instant" });
    }
  }

  onPressUp(e: KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();
    const { results, index } = this.getSearchResults();
    if (index === 0) return;
    dispatch("search-result-selected", results[index - 1]);
  }

  onPressDown(e: KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();
    const { results, index } = this.getSearchResults();
    if (index + 1 === results.length) return;
    dispatch("search-result-selected", results[index + 1]);
  }

  onSelectButton() {
    const { results, index } = this.getSearchResults();
    if (index >= 0 && results[index] && !results[index].disabled) {
      dispatch("search-result-submitted", results[index]);
      results[index].onPressEnter()
    }
  }

  onEditButton() {
    const { results, index } = this.getSearchResults();
    if (index >= 0 && results[index] && !results[index].disabled) {
      results[index].onPressShiftEnter()
    }
  }
}
